import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DumpsterService} from '../../../../_services/configuration-services';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../../_shared/notifications.service';
import {TranslateUtils} from '../../../../_shared/translate-utils';

@Component({
    selector: 'app-activate-dumpster-modal',
    templateUrl: './activate-dumpster-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActivateDumpsterModalComponent implements OnInit {

    @Input() deviceIdentifierToActivate!: string;
    crtLang = TranslateUtils.defaultLanguage;

    constructor(public activeModal: NgbActiveModal,
                private readonly dumpsterService: DumpsterService,
                private readonly notificationsService: NotificationsService) {
    }


    ngOnInit(): void {
        this.dumpsterService.canCustomerActivateDumpster(this.deviceIdentifierToActivate).pipe().subscribe({
            error: error => this.activeModal.close(error)
        });
    }

    activateService(): void {
        this.dumpsterService.activateDumpster(this.deviceIdentifierToActivate).pipe().subscribe(() => {
            this.notificationsService.success({
                title: 'services.waste.notifications.openSuccess',
            });

            this.activeModal.close();
        });
    }
}
